import b from 'b_';
import { Text } from 'platform-components/common';
import { SimpleCallback } from 'platform-components/common';
import React from 'react';
import { accessibleClick } from '@edu-frontend/modules/src/shared/lib/a11y';

import './calendar-plan-showcase__carousel-next-card-label.scss';
import { CalendarPlanShowcaseCarouselHeaderSize } from '../typings';

interface Props {
    onClick?: SimpleCallback;
    size: CalendarPlanShowcaseCarouselHeaderSize;
}

const getTextPropsByHeaderSize = (size: CalendarPlanShowcaseCarouselHeaderSize) => {
    switch (size) {
        case CalendarPlanShowcaseCarouselHeaderSize.S:
            return {
                size: Text.SIZE.XS,
                weight: Text.WEIGHT.S,
            };

        case CalendarPlanShowcaseCarouselHeaderSize.M:
        default:
            return {
                size: Text.SIZE.S,
                weight: Text.WEIGHT.M,
            };
    }
};

export const CalendarPlanShowcaseCarouselNextCardLabel = ({ onClick, size }: Props) => (
    <div className={b('calendar-plan-showcase', 'carousel-next-card-label', { size })} {...accessibleClick(onClick)}>
        <Text id="library.calendarPlanShowcase.nextWeekLabel" {...getTextPropsByHeaderSize(size)} />
    </div>
);
